export default {
  nav: {
    brandProducts: 'Produkty Positive', discover: 'Odkryj', allProducts: 'Wszystkie produkty',
    otherProducts: 'Pozostałe produkty: {count}',
    connectedApps: 'Połączone aplikacje', currentProduct: 'Jesteś w {product}',
    openApp: 'Otwórz {product} w nowej karcie', discoverProduct: 'Odkryj {product}',
  },
  actions: {
    tryFree: 'Wypróbuj za darmo', discover: 'Odkryj', discoverProduct: 'Odkryj {product}',
    backToCatalog: 'Powrót do wszystkich produktów',
    signIn: 'Zaloguj się', close: 'Zamknij',
  },
  agent: {
    useAssistant: 'Używaj w swoim asystencie AI', title: 'Używaj {product} w swoim asystencie AI',
    description: 'Połącz swojego asystenta z {product} za pomocą serwera MCP.',
    other: 'Inny',
    copyPrompt: 'Kopiuj prompt',
    copyDone: 'Skopiowano', copyRetry: 'Ponów',
    connectTitle: 'Wybierz swojego asystenta', connect: 'Połącz', availableFor: 'Dostępne dla {product}',
    connectionHint: 'Może być wymagane zalogowanie się i zatwierdzenie dostępu.',
    permissions: 'Twój asystent ma dostęp tylko do danych i działań, które autoryzujesz.',
    copy: 'Skopiuj prompt, aby połączyć agenta z {product}',
    copied: 'Prompt skopiowany. Wklej go w swoim agencie.', copyError: 'Nie udało się skopiować promptu. Spróbuj ponownie.',
  },
  catalog: {
    title: 'Odkryj produkty Positive', description: 'Narzędzia uzupełniające {product}.',
    descriptionDefault: 'Narzędzia dla zespołów marketingu i sprzedaży.', empty: 'Brak produktów do odkrycia.',
  },
  product: { featuresTitle: 'Co możesz zrobić z {product}' },
  status: { current: 'Bieżąca aplikacja', connected: 'Połączona aplikacja' },
  accessibility: { openMenu: 'Otwórz nawigację produktów', newTab: 'Otwiera się w nowej karcie' },
  categories: { emailSignatures: 'Podpisy e-mail', emailing: 'E-mail marketing', seo: 'SEO i GEO', socialMedia: 'Media społecznościowe', sales: 'Sprzedaż' },
  products: {
    signitic: {
      tagline: 'Zarządzanie podpisami e-mail',
      description: 'Zarządzaj wszystkimi podpisami e-mail w jednym miejscu i zamień je w kanał marketingowy.',
      features: ['Jednolite podpisy w całej firmie', 'Kampanie banerowe w każdej wiadomości e-mail', 'Analiza kliknięć i zasięgu'],
    },
    user: {
      tagline: 'E-mail marketing i angażowanie klientów',
      description: 'Automatyzacja, CRM i czat na żywo, aby angażować kontakty we właściwym momencie.',
      features: ['Automatyczne ścieżki e-mail i SMS', 'CRM z kontaktami i szansami sprzedaży', 'Czat na żywo na Twojej stronie'],
    },
    surfer: {
      tagline: 'Optymalizacja treści pod SEO i GEO',
      description: 'Twórz treści, które zajmują wysokie pozycje w Google i są cytowane przez asystentów AI.',
      features: ['Briefy treści pomagające osiągać wysokie pozycje w Google', 'Cytowania w ChatGPT i odpowiedziach AI', 'Pisanie artykułów z pomocą AI'],
    },
    iconosquare: {
      tagline: 'Zarządzanie mediami społecznościowymi i analityka',
      description: 'Planuj publikacje, odpowiadaj i analizuj wyniki wszystkich sieci społecznościowych na jednej platformie.',
      features: ['Planowanie postów w każdej sieci', 'Jedna skrzynka na komentarze i wiadomości prywatne', 'Analizy i raporty'],
    },
    humanlinker: {
      tagline: 'Asystent sprzedaży oparty na AI',
      description: 'Docieraj do każdego potencjalnego klienta w spersonalizowany sposób i zamieniaj rozmowy w sprzedaż.',
      features: ['Rekomendacje potencjalnych klientów oparte na AI', 'Spersonalizowane sekwencje kontaktu', 'Przygotowanie do spotkania jednym kliknięciem'],
    },
    ubic: {
      tagline: 'Równoległe wybieranie numerów dla zespołów sprzedaży',
      description: 'Narzędzie do równoległego wybierania numerów, dzięki któremu zespoły sprzedaży docierają do większej liczby potencjalnych klientów w krótszym czasie.',
      features: ['Dzwoń do kilku potencjalnych klientów jednocześnie', 'Trafiają do Ciebie tylko odebrane połączenia', 'Synchronizacja z Twoim CRM'],
    },
    nocrm: {
      tagline: 'Zarządzanie leadami dla handlowców',
      description: 'Śledź każdego leada od pierwszego kontaktu do finalizacji sprzedaży, bez złożoności CRM.',
      features: ['Wszystkie leady w jednym lejku sprzedażowym', 'Przypomnienia, dzięki którym nie tracisz szans', 'Aplikacja mobilna do pracy w terenie'],
    },
  },
};
